import Vue from 'vue';

export async function all() {
  const { data } = await Vue.axios.get('/api/regions');

  return data.data;
}

export async function first() {
  const { data } = await Vue.axios.get('/api/regions/first');

  return data.data;
}

export async function second(id) {
  const { data } = await Vue.axios.get(`/api/regions/${id}/second`);

  return data.data;
}
